// UnsavedChangesModal Component
// Displays a confirmation dialog when user tries to navigate away with unsaved changes
// Listens to navigation:unsafe-changes custom events from NavigationManager

import React, { useState, useEffect } from 'react';
import { RevoltModal, RevoltButton } from './';
import './UnsavedChangesModal.css';

export function UnsavedChangesModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const handleUnsafeChanges = (event) => {
      const { hasUnsafe, message: msg } = event.detail;
      if (hasUnsafe) {
        setMessage(msg);
        setIsOpen(true);
      }
    };

    window.addEventListener('navigation:unsafe-changes', handleUnsafeChanges);

    return () => {
      window.removeEventListener('navigation:unsafe-changes', handleUnsafeChanges);
    };
  }, []);

  const handleConfirm = async () => {
    setIsOpen(false);
    setMessage(null);

    // Import navigationManager dynamically to avoid circular dependencies
    const { navigationManager } = await import('../managers/navigation-manager');
    await navigationManager.executePendingNavigation();
  };

  const handleCancel = () => {
    setIsOpen(false);
    setMessage(null);

    // Import navigationManager dynamically to avoid circular dependencies
    import('../managers/navigation-manager').then(({ navigationManager }) => {
      navigationManager.cancelPendingNavigation();
    });
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={handleCancel}
      title="Unsaved Changes"
      containerClassName="unsaved-changes-modal"
      showCloseButton={false}
    >
      <div className="unsaved-changes-content">
        <div className="unsaved-changes-icon">
          <i className="fa-solid fa-triangle-exclamation"></i>
        </div>
        <p className="unsaved-changes-message">
          {message || 'You have unsaved changes. Are you sure you want to leave?'}
        </p>
        <p className="unsaved-changes-hint">
          Your changes will be lost if you leave without saving.
        </p>
        <div className="unsaved-changes-actions">
          <RevoltButton variant="ghost" onClick={handleCancel}>
            Cancel
          </RevoltButton>
          <RevoltButton variant="accent" onClick={handleConfirm}>
            Leave Without Saving
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

